'use strict'

const KEYCLOAK_CONFIG = {
    local: {
        url: 'https://keycloak.staging.kidplus.fairtility.com/auth',
        realm: 'fairtility',
        clientId: 'eq',
        onLoad: 'check-sso'
    },
    development: {
        url: 'https://keycloak.staging.kidplus.fairtility.com/auth',
        realm: 'fairtility',
        clientId: 'eq',
        onLoad: 'check-sso'
    },
    production: {
        url: 'https://keycloak.kidplus.fairtility.com/auth',
        realm: 'blast',
        clientId: 'eq',
        onLoad: 'check-sso'
    }
}

const HELP_CENTER_BASE_URL = {
    local: 'https://storage.cloud.google.com/dev-eq-help-center',
    development: 'https://storage.cloud.google.com/dev-eq-help-center',
    production: `${window.origin}/help-center`
}

const AUTH0_CONFIG = {
    local: {
        domain: 'otp.staging.chloe.fairtility.com',
        client_id: 'W32DYlUWVYw9v8G5guRcU2vMVfdt2qX8',
        redirect_uri: `https://staging.kidplus.fairtility.com/patient-share`
    },
    development: {
        domain: 'otp.staging.chloe.fairtility.com',
        client_id: 'S0OSd7YX5BHRQne3tLHQWprWJFkHWVQ6',
        redirect_uri: `http://localhost:8081/patient-share`
    },
    production: {
        domain: 'otp.chloe.fairtility.com', // 'otp.chloe.fairtility.com'
        client_id: 'IaLwQouN34TP61UlTLEk5fAAETTZgQSw', // 'W32DYlUWVYw9v8G5guRcU2vMVfdt2qX8'
        redirect_uri: `https://us.chloe-blast.fairtility.com/patient-share` // `https://kidplus.fairtility.com/patient-share`
    }
}

const MIN_TOKEN_VALIDITY = 70

const PGTA_VALUES = [
    null,
    'euploid_d3',
    'euploid_d5',
    'euploid_d6',
    'euploid_d7',
    'aneuploid_d3',
    'aneuploid_d5',
    'aneuploid_d6',
    'aneuploid_d7',
    'mosaic_d3',
    'mosaic_d5',
    'mosaic_d6',
    'mosaic_d7',
    'no_result',
    'failed_amplification'
]

const TREATMENT_PAGE_VIEWS = {
    WELL_CARDS: 'well_cards',
    COMPARE_WELLS: 'compare_wells',
    PERFORMANCE_TABLE: 'performance_table',
    ISTANBUL_TABLE: 'istanbul_table'
}

const ROUTES = {
    HOME_PAGE: 'HomePage',
    TREATMENTS: 'Treatments',
    CYCLE_REPORT: 'CycleReport',
    FERT_REPORT: 'FertReport',
    WELL: 'Wells',
    HELP_CENTER: 'HelpCenter',
    PRINT_WELL: 'PrintWell',
    PATIENT_SHARE_WELCOME: 'PatientShareWelcome',
    PATIENT_SHARE_TREATMENT: 'PatientShareTreatment',
    ADMIN_OPERATIONS: 'AdminOperations',
    EMR_TREATMENT_LINK_PAGE: 'EmrTreatmentLink'
}

const VIDEO_SEEK_MODES = {
    TIME: 'time',
    MK_EVENT: 'events',
    ISTANBUL_EVENT: 'istanbul',
    DAY: 'day'
}

const ALL_MK_EVENTS = [
    'tpna',
    'tpnf',
    't2',
    't3',
    't4',
    't5',
    't6',
    't7',
    't8',
    't9+',
    'tm',
    'tsb',
    'tb',
    'teb'
]
const OVERLAY_MK_EVENTS = ['t2', 't3', 't4', 't5', 't6', 't8', 't9+', 'tm', 'tsb', 'tb', 'teb']

const ALL_ISTANBUL_EVENTS = [
    {
        label: 'day1',
        day: 1,
        hours: 18.0,
        tooltipText: '17 ± 1'
    },
    {
        label: 'day2',
        day: 2,
        hours: 45.0,
        tooltipText: '44 ± 1'
    },
    {
        label: 'day3',
        day: 3,
        hours: 69.0,
        tooltipText: '68 ± 1'
    },
    {
        label: 'day4',
        day: 4,
        hours: 94.0,
        tooltipText: '92 ± 2'
    },
    {
        label: 'day5',
        day: 5,
        hours: 118.0,
        tooltipText: '116 ± 2'
    },
    {
        label: 'day6',
        day: 6,
        hours: 138.0,
        tooltipText: '136 ± 2'
    },
    {
        label: 'day7',
        day: 7,
        hours: 162.0,
        tooltipText: '160 ± 2'
    }
]

const ALL_ISTANBUL_EVENTS_MAP = {
    tpna: 'PN',
    tpnf: 'PN',
    t2: '2 cell',
    t3: '3 cell',
    t4: '4 cell',
    t5: '5 cell',
    t6: '6 cell',
    t7: '7 cell',
    t8: '8 cell',
    t9: '9 cell',
    't9+': '9 cell',
    tm: 'Morula',
    tsb: 'S. Blast',
    tb: 'Blast',
    teb: 'E. Blast'
}

const ALL_DAYS = [
    {
        day: 0,
        label: 'day0',
        hours: 0.0
    },
    {
        day: 1,
        label: 'day1',
        hours: 10.0
    },
    {
        day: 2,
        label: 'day2',
        hours: 34.0
    },
    {
        day: 3,
        label: 'day3',
        hours: 58.0
    },
    {
        day: 4,
        label: 'day4',
        hours: 82.0
    },
    {
        day: 5,
        label: 'day5',
        hours: 106.0
    },
    {
        day: 6,
        label: 'day6',
        hours: 130.0
    },
    {
        day: 7,
        label: 'day7',
        hours: 154.0
    }
]

const INSTRUMENT_TYPE = {
    VITRO: 'VITRO',
    GERI: 'GERI',
    MIRI: 'MIRI'
}

const VITRO_API_VERSIONS = ['1.3']

const GERI_API_VERSIONS = ['1.0']

const MIRI_API_VERSIONS = ['1.3']

const TREATMENT_STATUS = {
    IN_PROGRESS: 'IN_PROGRESS',
    INACTIVE: 'INACTIVE'
}

const DATE_FORMAT = 'DD.MM.YY'

const MAX_WELL_TIME_HOURS = 120
const MIN_HOURS_FOR_INFERENCE = 30
const HOME_PAGE_FINISHED_SLIDE_PAGE_COUNT = 51
const CLINIC_LOGO_MAX_UPLOAD_SIZE = 2000000 // 2MB

const DEFAULT_AVATAR = '/static/img/default-profile.png'

const PATIENT_SHARE_ERRORS = {
    BIRTH_YEAR_MISMATCH: 'birthYear_mismatch',
    LINK_IS_NOT_VALID: 'invalid_link'
}

const WELL_STATUS_ICONS_PATH = '/static/svg/well_status'

const TLI_CHLOE_TIME_DIFFERENCE_ICONS_PATH = '/static/svg/tli_chloe_time_difference'

const SLIDE_TIME_ATTRIBUTION = {
    FINISHED: 'finished',
    ONGOING: 'ongoing'
}

const SCORE_THRESHOLDS = {
    kidScoreHigh: 5,
    kidScoreLow: 2,
    blastScoreHigh: 7,
    blastScoreLow: 4
}

const PRODUCTS = {
    OQ: 'OQ',
    EQ: 'EQ'
}

const EMR_TYPES = {
    VREPRO: 'VREPRO',
    MEDITEX: 'MEDITEX',
    IDEAS: 'IDEAS'
}

const MINIMUM_MINUTES_DELAY_FOR_DELAYED_SLIDE = 20

module.exports = {
    KEYCLOAK_CONFIG,
    HELP_CENTER_BASE_URL,
    AUTH0_CONFIG,
    MIN_TOKEN_VALIDITY,
    TREATMENT_PAGE_VIEWS,
    ROUTES,
    VIDEO_SEEK_MODES,
    ALL_MK_EVENTS,
    OVERLAY_MK_EVENTS,
    ALL_ISTANBUL_EVENTS,
    ALL_ISTANBUL_EVENTS_MAP,
    ALL_DAYS,
    MAX_WELL_TIME_HOURS,
    MIN_HOURS_FOR_INFERENCE,
    DEFAULT_AVATAR,
    INSTRUMENT_TYPE,
    TREATMENT_STATUS,
    DATE_FORMAT,
    VITRO_API_VERSIONS,
    GERI_API_VERSIONS,
    MIRI_API_VERSIONS,
    HOME_PAGE_FINISHED_SLIDE_PAGE_COUNT,
    PATIENT_SHARE_ERRORS,
    CLINIC_LOGO_MAX_UPLOAD_SIZE,
    WELL_STATUS_ICONS_PATH,
    SLIDE_TIME_ATTRIBUTION,
    SCORE_THRESHOLDS,
    PRODUCTS,
    EMR_TYPES,
    MINIMUM_MINUTES_DELAY_FOR_DELAYED_SLIDE,
    PGTA_VALUES,
    TLI_CHLOE_TIME_DIFFERENCE_ICONS_PATH
}
